import { cx } from '@emotion/css';
import { MFormTextField, MTypography, PhoneNumbersField } from 'src/lib';
import { EntityInformation } from 'src/models';
import { Color, Spacing } from 'src/styles';

interface EntityInformationViewProps {
  entityInformation?: EntityInformation;
}

export const EntityInformationView = ({ entityInformation }: EntityInformationViewProps) => {
  return (
    <>
      <MFormTextField label='Entity Name' value={entityInformation?.name} />
      <MFormTextField label='Tax ID' value={entityInformation?.taxId} />
      {entityInformation?.phoneNumber && (
        <MFormTextField
          label='Phone Number(s)'
          value={<PhoneNumbersField value={[{ phoneNumber: entityInformation.phoneNumber }]} />}
        />
      )}
      <MTypography variant='h5' weight='bold' color={Color.Gray8} className={cx(Spacing.mb32, Spacing.mt40)}>
        Physical Address
      </MTypography>
      <MFormTextField
        label='Address Line 1'
        value={entityInformation?.address?.address1}
        testId={`entity-address-line-1`}
      />
      <MFormTextField
        label='Address Line 2 (Opt.)'
        value={entityInformation?.address?.address2}
        testId={`entity-address-line-2`}
      />
      <MFormTextField
        label='Country'
        value={entityInformation?.address?.country?.label}
        testId={`entity-address-country`}
      />
      <MFormTextField label='City' value={entityInformation?.address?.city} testId={`entity-address-city`} />
      <MFormTextField label='State' value={entityInformation?.address?.state?.label} testId={`entity-address-state`} />
      <MFormTextField
        label='Postal Code'
        value={entityInformation?.address?.postalCode}
        testId={`entity-address-postal-code`}
      />
    </>
  );
};
